<template>
	<div class="w-100 py-3 navbar-background position-fixed z-3 top-0">
		<div class="container">
			<a
				:href="`https://wa.me/${contacts[0]?.whatsapp}`"
				target="_blank"
				class="whatsapp-button"
				:class="{ show: isFarFromTop }"
				>
				<i class="fab fa-whatsapp"></i>
			</a>
			<div class="container-fluid">
				<nav class="navbar navbar-expand-lg w-100">
					<router-link class="navbar-brand logo-margin" to="/">
						<img src="@/assets/images/Logo-new.svg" alt="logo" class="main-image-width">
					</router-link>
					<div class="d-flex align-items-center">
						<ul class="navbar-nav d-block d-lg-none px-4">
							<li class="nav-item">
								<a class="nav-link pointer" @click="changeLang()">{{$t('language')}}</a>
							</li>
						</ul>
						<button
							class="navbar-toggler"
							type="button"
							data-bs-toggle="collapse"
							data-bs-target="#navbarNav"
							style="color: white"
						>
							<span class="navbar-toggler-icon"></span>
						</button>
					</div>
					<div class="collapse navbar-collapse" id="navbarNav">
						<div class="d-flex justify-content-center justify-content-lg-between w-100">
							<div class="d-flex flex-column flex-lg-row">
								<ul v-for="item in navs" :key="item.id" class="navbar-nav nav-items-padding">
									<li class="nav-item pb-3 pb-lg-0">
										<div
											v-if="item.id === 3"
											class="dropdown custom-dropdown"
											:class="{
												'dropend': isMdScreen && $i18n.locale === 'en',
												'dropstart': isMdScreen && $i18n.locale !== 'en'
											}"
										>
											<div
												class="nav-link nav-item-font pointer text-white"
												data-bs-toggle="dropdown"
												:class="$i18n.locale === 'en' ? 'ps-xl-5' : ''"
											>
												<img :src="item.image" width="15" class="mb-1">
												<span class="element-padding bold">
													{{ item.name }}
												</span>
												<i
													v-if="item.id === 3"
													class="fa-solid fa-chevron-down px-1 chevron-icon-style d-none d-lg-inline"
												></i>
											</div>
											<ul class="dropdown-menu">
												<li v-for="item in menuNavs" :key="item.id" >
													<div
														v-bind="!isMdScreen ? { 'data-bs-toggle': 'collapse', 'data-bs-target': '#navbarNav' } : {}"
														class="w-100"
													>
														<router-link
															class="text-decoration-none text-black dropdown-item"
															:to="'/all-products/' + item.slug"
															exact-active-class="active-nav-element"
														>
														<div class="w-100 h-100">
															{{ item.name }}
														</div>
														</router-link>
													</div>
												</li>
											</ul>
										</div>
										<div
											v-else
											v-bind="!isMdScreen ? { 'data-bs-toggle': 'collapse', 'data-bs-target': '#navbarNav' } : {}"
										>
											<router-link
												class="nav-link nav-item-font"
												:class="$i18n.locale === 'en' ? 'ps-xl-5 ps-4' : ''"
												:to="item.to"
												exact-active-class="active-nav-element"
											>
												<img :src="item.image" width="15" class="mb-1">
												<span class="element-padding bold">
													{{ item.name }}
												</span>
											</router-link>
										</div>
									</li>
								</ul>
							</div>
							<ul class="navbar-nav d-none d-lg-block">
								<li class="nav-item">
									<a class="nav-link pointer" @click="changeLang()">
										<img src="@/assets/images/globe.svg" alt="" width="23" class="px-1 pb-1">
										{{$t('language')}}
									</a>
								</li>
							</ul>
						</div>
					</div>
				</nav>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	name: 'NavbarVue',
	data () {
		return {
			isFarFromTop: false,
			isMdScreen: false,
			navs: [
				{
					id: 1,
					name: this.$t('navbar.main'),
					image: require('@/assets/images/house-blank.svg'),
					to: '/'
				},
				{
					id: 2,
					name: this.$t('navbar.about'),
					image: require('@/assets/images/screw.svg'),
					to: '/about-us'
				},
				{
					id: 3,
					name: this.$t('navbar.categories'),
					image: require('@/assets/images/apps.svg'),
					to: '/all-categories'
				},
				{
					id: 4,
					name: this.$t('navbar.products'),
					image: require('@/assets/images/boxes.svg'),
					to: '/all-products'
				},
				{
					id: 5,
					name: this.$t('navbar.contact-us'),
					image: require('@/assets/images/phone-flip.svg'),
					to: '/contact-us'
				}
			]
		}
	},

	computed: {
		...mapState({
			categories: state => state.categories.categories,
			contacts: state => state.contacts.contacts
		}),

		menuNavs () {
			return [{ id: 0, slug: '', name: this.$t('all-categories'), image: { url: null } }, ...this.categories.map(c => ({
				id: c.id,
				slug: c.slug,
				name: c.name
			}))]
		}
	},

	methods: {
		changeLang () {
			const lang = localStorage.getItem('lang') || 'ar'
			if (lang === 'ar') {
				localStorage.setItem('lang', 'en')
			} else {
				localStorage.setItem('lang', 'ar')
			}
			this.$router.go(0)
		},

		checkScreen () {
			this.isMdScreen = window.innerWidth >= 992;
		}

	},

	mounted () {
		window.addEventListener('scroll', (e) => {
			this.isFarFromTop = window.innerHeight / 12 < window.pageYOffset;
		});

		this.checkScreen();
		window.addEventListener('resize', this.checkScreen);
	},

	beforeDestroy () {
		window.removeEventListener('resize', this.checkScreen);
	},

}
</script>

<style lang="scss" scoped>
@import '../scss/vars.scss';

.navbar {
	background: transparent !important;
}

.logo-margin {
	@media (max-width: 992px) {
		margin: 0;
	}
}

.navbar-nav .nav-link {
	color: white;

	// @media (max-width: 992px) {
	// 	color: black;
	// }

	[dir='ltr'] & {
		padding-left: 20px !important;
		@media (max-width: 1200px) {
			font-size: 12px;
		}
	}

	[dir='rtl'] & {
		padding: 0 !important;
	}
}
// #navbarNav {
// 	// @media(max-width:992px) {
// 	// 	background: white;
// 	// 	border-radius: 10px;
// 	// 	padding: 15px 0;
// 	// }
// 	// box-shadow: 0px 5px 10px 20px rgba(0, 0, 0, 0.05);
// }

.nav-items-padding {
	@media (max-width: 1200px) {
		padding: 0 10px;
	}

	[dir='ltr'] & {
		@media (max-width: 1200px) {
			padding: 0;
		}
	}
}

.navbar-height {
	height: 100px;
	display: flex;
	align-items: center;
}

.nav-item-font {
	font-size: 14px;
}

.chevron-icon-style {
	font-size: 10px;
	color: white;
	padding-left: 10px;
}

.navbar-background {
	background-color: $primary;
	// box-shadow: 0px 5px 15px 15px rgba(0, 0, 0, 0.08);
}

.element-padding {
	padding-right: 2px;
}

.active-nav-element {
	color: $secondary !important;
	i {
		color: $secondary !important;
	}

	// not working! :(
	img {
		color: $secondary !important;
	}
}

.main-image-width {
	width: 200px;
	@media (max-width: 678px) {
		width: 150px;
	}
	@media (max-width: 475px) {
		width: 125px;
	}
}

// nav menu class
.custom-dropdown {
	position: relative;
	cursor: pointer;
	padding-bottom:0px;
	ul {
		list-style: none;
		margin: 0;
		border-radius: 5px;
		padding: 0;
		position: absolute;
		width: 100%;
		background: #FAFAFA;
		z-index: 10;
		left: -25px;

		@media (max-width: 992px) {
			right: -33px;

			[dir='ltr'] & {
				right: 0;
				left: -14px;
			}
		}
		.dropdown-item {
			padding: 8px 10px;
			text-align: start;
			border-radius: 5px;
			font-size: 12px;
			color: $secondary;
		}
		.dropdown-item:hover {
			background: #ddd;
		}
		.dropdown-item.active-nav-element {
			background-color: $secondary;
			color: white !important;
		}
	}
}

// navbar button styles
.navbar-toggler {
  border-color: white;
}

.navbar-toggler-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='white' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3E%3C/svg%3E");
}

// whatsapp button
.whatsapp-button {
	position: fixed;
	bottom: 5rem;
	left: 5rem;
	padding: 0;
	text-decoration: none;
	width: 5rem;
	height: 5rem;
	* {
		font-size: 3rem;
	}
	display: none;
	&.show {
		display: flex;
	}
	align-items: center;
	justify-content: center;
	color: white;
	background-color: #4baf4f;
	border-radius: 50%;
	z-index: 10;

	@media (max-width: 768px) {
		position: fixed;
		bottom: 2rem;
		left: 2rem !important;
	}

	[dir='ltr'] & {
		right: 5rem;
		left: auto !important;
		@media (max-width: 768px) {
			position: fixed;
			bottom: 2rem;
			right: 2rem !important;
		}
	}
}

// css changes for diffirent translates

html[dir = 'ltr'] .chevron-icon-style {
	padding-right: 10px;
}

html[dir = 'ltr'] .element-padding {
	padding-left: 2px;
}

html[dir = 'ltr'] .whatsapp-button {
	left: auto;
	right: 5rem;
}
</style>
